import React from 'react';
import { batch } from 'react-redux';
import { conditionTypeOptionsSelector } from '../../../../../redux/selectors/builder';
import {
  ICohortRow,
  IRowMeta,
  removeErrorAction,
  setCohortRowSimpleTypeKey,
} from '../../../../../redux/slices/oldBuilder';
import { cohortConditionFilterTooltipOption } from '../../../../KubitTooltip/globalTooltips';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import { SimpleCohortTypeKey } from '../../../../../utils/apollo/graphqlSchema';
import BuilderEnumSelect from '../../../BuilderFields/BuilderEnumSelect';

interface IProps {
  rowMeta: IRowMeta;
  cohortRow: ICohortRow;
}

export default ({ rowMeta, cohortRow }: IProps) => {
  const dispatch = useAppDispatch();

  const { simpleCohortTypeKey } = cohortRow;

  const simpleCohortTypes = useAppSelector((state) =>
    conditionTypeOptionsSelector(state),
  );

  const handleChange = (value: SimpleCohortTypeKey) => {
    batch(() => {
      dispatch(removeErrorAction({ rowMeta, errorKey: '' }));
      dispatch(
        setCohortRowSimpleTypeKey({
          value,
          rowMeta,
        }),
      );
    });
  };

  return (
    <BuilderEnumSelect
      label={'Type'}
      enumOptions={simpleCohortTypes}
      selectedOption={simpleCohortTypeKey}
      onChange={handleChange}
      tooltipOption={cohortConditionFilterTooltipOption}
    />
  );
};
